module.exports = __webpack_public_path__ + "img/search.cd73f45b.svg";